/** The first request is a dry refusal when the server requires explicit consent. */
export async function confirmJobseekerEdit<T>(save: (confirmed: boolean) => Promise<T>): Promise<T | undefined> {
  try { return await save(false); }
  catch (error: unknown) {
    if (!(error instanceof Error) || !("code" in error) || error.code !== "jobseeker_edit_confirmation_required") throw error;
    if (!window.confirm(error.message)) return undefined;
    return save(true);
  }
}
